import React from "react";

export const LostObjectsTab = () => {
	return <div>LostObjectsTab</div>;
};
